(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rh-x-sr-gallery-extras"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sr-gallery-extras')) customElements.define('sr-gallery-extras',class extends HTMLElement{
 connectedCallback(){if(this.mounted)return;queueMicrotask(()=>{if(this.mounted||!this.isConnected)return;const area=this.closest('.product-information');const media=area?.querySelector('.product-information__media');const slides=media?.querySelector('slideshow-container');if(!media||!slides)return;this.mounted=true;this.brandLine=this.querySelector(".sr-gallery-brand-line");if(this.brandLine)media.prepend(this.brandLine);this.badge=this.querySelector('.sr-gallery-badge');this.caption=this.querySelector('.sr-gallery-caption');if(this.dataset.placement !== "details")media.append(this);if(this.badge)media.prepend(this.badge);if(this.caption)slides.after(this.caption);});}
 disconnectedCallback(){queueMicrotask(()=>{if(this.isConnected)return;this.brandLine?.remove();this.badge?.remove();this.caption?.remove();});}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rh-x-sr-product-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sr-review-slider')) {
  customElements.define('sr-review-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const track = this.querySelector('.sr-review-slider__track');
      if (!track) return;
      const buttons = this.querySelectorAll('[data-review-step]');
      track.setAttribute('role', 'region');
      const update = () => {
        this.classList.toggle('has-multiple', track.children.length > 1);
        for (const button of buttons) {
          button.disabled = Number(button.dataset.reviewStep) < 0
            ? track.scrollLeft <= 2
            : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
      };
      const step = direction => {
        const card = track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-review-step]');
        if (button && !button.disabled) step(Number(button.dataset.reviewStep));
      }, {signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        step(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      track.addEventListener('scroll', update, {passive:true, signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rh-x-sr-product-tabs"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sr-product-tabs'))customElements.define('sr-product-tabs',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const nav=this.querySelector('[role=tablist]'),tabs=[...nav.children],panels=[...this.querySelectorAll('details')];nav.hidden=false;const select=i=>{tabs.forEach((t,n)=>{t.setAttribute('aria-selected',n===i);t.tabIndex=n===i?0:-1;panels[n].hidden=n!==i;panels[n].setAttribute('role','tabpanel');panels[n].tabIndex=0;panels[n].setAttribute('aria-labelledby',t.id);panels[n].querySelector('summary').hidden=true;});};nav.addEventListener('click',e=>{const i=tabs.indexOf(e.target.closest('button'));if(i>=0)select(i);});nav.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();let i=tabs.indexOf(document.activeElement);i=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;select(i);tabs[i].focus();});select(0);}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rh-x-sr-product-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sr-product-videos')) { customElements.define('sr-product-videos', class extends HTMLElement {
 connectedCallback(){if(this.abortController)return;this.abortController=new AbortController();const signal=this.abortController.signal;this.setupHover(signal);this.addEventListener('click',e=>{const play=e.target.closest('[data-sr-play]');if(play){const card=play.closest('.sr-video-card');const dialog=card.querySelector('dialog');const template=card.querySelector('template');if(!dialog||!template)return;this.stopPreviews();this.opener=play;dialog.querySelector('.sr-video-dialog__player').replaceChildren(template.content.cloneNode(true));dialog.showModal();dialog.querySelector('video')?.play().catch(()=>{});}const close=e.target.closest('[data-sr-close]');if(close)close.closest('dialog').close();if(e.target.tagName==='DIALOG'){const b=e.target.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)e.target.close();}},{signal});this.addEventListener('close',e=>{if(!e.target.matches('.sr-video-dialog'))return;e.target.querySelector('.sr-video-dialog__player').replaceChildren();this.opener?.focus();},{capture:true,signal});}
 setupHover(signal){
  this.addEventListener('pointerover',e=>{
   const card=e.target.closest('.sr-video-card');
   if(!card||card.contains(e.relatedTarget)||e.pointerType==='touch'||!matchMedia('(hover: hover)').matches||matchMedia('(prefers-reduced-motion: reduce)').matches||this.querySelector('dialog[open]'))return;
   this.stopPreviews();
   let video=card.querySelector('.sr-video-card__preview');
   if(!video){
    const source=card.querySelector('template')?.content.querySelector('video');
    if(!source)return;
    video=source.cloneNode(true);
    video.removeAttribute('id');video.className='sr-video-card__preview';
    video.controls=false;video.muted=true;video.defaultMuted=true;video.loop=true;video.playsInline=true;
    video.setAttribute('aria-hidden','true');video.setAttribute('tabindex','-1');
    card.querySelector('.sr-video-card__cover').append(video);
   }
   video.hidden=false;video.play().catch(()=>{video.hidden=true;});
  },{signal});
  this.addEventListener('pointerout',e=>{
   const card=e.target.closest('.sr-video-card');
   if(card&&!card.contains(e.relatedTarget))this.stopPreviews();
  },{signal});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)this.stopPreviews();},{signal});
 }
 stopPreviews(){for(const video of this.querySelectorAll('.sr-video-card__preview')){video.pause();video.hidden=true;}}
 disconnectedCallback(){this.stopPreviews();this.querySelectorAll('dialog[open]').forEach(d=>d.close());this.abortController?.abort();this.abortController=null;}
});}
  } catch(e) { console.error(e); }
})();

})();
